/**
 * Generates a cryptographically secure 32 bit unsigned int
 * @returns integer
 */
export const randomU32Int = () => {
  const randomArray = new Uint32Array(1)
  const res = window.crypto.getRandomValues(randomArray)
  return res[0]
}
/**
 * Waits for specifid number of milliseconds
 * Not precise
 * @param {*} milliseconds number of milliseconds to wait
 */
export const waitMS = milliseconds =>
  new Promise(resolve => setTimeout(() => resolve(), milliseconds))

/**
 * Retries execution of promise
 * @param {Promise} promise promise to execute and retry
 * @param {any} opts arguments to pass to promise
 * @param {number} retries number of retries to execute
 * @param {number} timeout minimum timeout for first retry
 * @param {number} factor factor by which to increase timeout with every retry
 * @param {boolean} randomize if true, multiplies timeout by a random factor between 1 and 2
 * @returns
 */
export const retryPromise = async (
  promise,
  opts,
  retries = 3,
  timeout = 50,
  factor = 2,
  randomize = true
) => {
  let waitTime = timeout
  for (let i = 0; i < retries; i++) {
    try {
      if (i > 0) {
        waitTime *= factor
        if (randomize) {
          const variance = parseFloat(`1.${randomU32Int()}`)
          waitTime *= variance
        }
        // eslint-disable-next-line no-await-in-loop
        await waitMS(waitTime)
      }
      // eslint-disable-next-line no-await-in-loop
      const result = await promise(...opts)
      return result
    } catch (error) {
      if (i === retries - 1) {
        throw error
      }
    }
  }
}
